import type { RefObject } from 'react';

interface ArticlePreviewRefs {
  elementRef?: RefObject<HTMLElement | null>;
  backgroundRef?: RefObject<HTMLDivElement | null>;
  imageContainerRef?: RefObject<HTMLDivElement | null>;
  dateHolderRef?: RefObject<HTMLDivElement | null>;
  ctaRef?: RefObject<HTMLDivElement | null>;
  ctaHolderRef?: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { imageContainerRef, elementRef }: ArticlePreviewRefs,
): void {
  if (imageContainerRef?.current && elementRef?.current) {
    const containerHeight = elementRef.current.offsetHeight;
    const imageHeight = imageContainerRef.current.offsetHeight;
    const distance = imageHeight - containerHeight;
    const offset = (distance / imageHeight) * 100;

    timeline.fromTo(
      imageContainerRef.current,
      { yPercent: -offset },
      { duration: 0.5, ease: 'none', yPercent: 0, scale: 1.1 },
    );
  }
}

export function setupMouseEnterTimeline(
  timeline: gsap.core.Timeline,
  { dateHolderRef, ctaRef, ctaHolderRef }: ArticlePreviewRefs,
): void {
  if (dateHolderRef?.current) {
    timeline.to(dateHolderRef.current, { duration: 0.3, ease: 'Quad.easeInOut', xPercent: -50 }, 0);

    if (ctaHolderRef?.current) {
      const width = ctaRef?.current?.offsetWidth;
      timeline.fromTo(
        ctaHolderRef.current,
        { width: 0 },
        { width, duration: 0.3, ease: 'Quad.easeInOut' },
        0,
      );
    }
  }
}

export function setupMouseLeaveTimeline(
  timeline: gsap.core.Timeline,
  { dateHolderRef, ctaHolderRef }: ArticlePreviewRefs,
): void {
  if (dateHolderRef?.current) {
    timeline.to(dateHolderRef.current, { duration: 0.3, ease: 'Quad.easeInOut', xPercent: 0 });

    if (ctaHolderRef?.current) {
      timeline.to(ctaHolderRef.current, { duration: 0.3, ease: 'Quad.easeInOut', width: 0 }, 0);
    }
  }
}
